<div class="flex h-full items-center justify-center">
  @if (!resolvedImageSrc) {
    @if (isHundredPercentSize) {
      <div class="flex w-full flex-auto justify-center" [style.background-color]="info()?.initialsColor || '#d0d0d0'">
        <ng-container [ngTemplateOutlet]="avatarContent"></ng-container>
      </div>
    } @else {
      <ng-container [ngTemplateOutlet]="avatarContent"></ng-container>
    }
  } @else {
    <div
      class="overflow-hidden rounded-full"
      [style.border-color]="resolvedBorderColor"
      [style.border-style]="'solid'"
      [style.border-width.px]="showBorder ? 2 : 0"
      [style.height.%]="isHundredPercentSize ? 100 : null"
      [style.width.%]="isHundredPercentSize ? 100 : null"
      [style.height.px]="isHundredPercentSize ? null : size"
      [style.width.px]="isHundredPercentSize ? null : size"
      [style.min-height.px]="isHundredPercentSize ? null : size"
      [style.min-width.px]="isHundredPercentSize ? null : size"
    >
      <img
        [src]="resolvedImageSrc"
        [alt]="info()?.name || initials"
        class="h-full w-full object-cover"
        (error)="onImgLoadError()"
      />
    </div>
  }
</div>

<ng-template #avatarContent>
  <div
    class="flex items-center justify-center rounded-full"
    [style.border-color]="resolvedBorderColor"
    [style.border-style]="'solid'"
    [style.border-width.px]="showBorder ? 2 : 0"
    [style.font-size.px]="fontSize"
    [style.height.px]="size"
    [style.width.px]="size"
    [style.min-height.px]="size"
    [style.min-width.px]="size"
    [style.background-color]="info()?.initialsColor || '#d0d0d0'"
    [style.color]="resolvedInitialsTextColor"
  >
    @if (!info()?.type || info()?.type === 1) {
      <!-- Color comes from the parent's [style.color], not a `text-*` class (important:true would beat it). -->
      <div class="whitespace-nowrap font-medium" [style.line-height.px]="fontSize">
        {{ initials }}
      </div>
    } @else if (info()?.type === 2) {
      <ng-icon name="lucideMapPin" class="icon-size-4 text-white"></ng-icon>
    } @else if (info()?.type === 3) {
      <ng-icon name="lucideUsers" class="icon-size-4 text-white"></ng-icon>
    }
  </div>
</ng-template>
